import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import LacBadge from "../components/lac/LacBadge";
import { toast } from "sonner";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { api, setToken, getToken, formatApiError } from "../lib/api";

const inputCls = "bg-[#0d0d0d] border-white/10 text-white placeholder:text-zinc-600 focus-visible:ring-[#D946EF] focus-visible:border-[#D946EF] h-12 rounded-sm";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (getToken()) {
      api.get("/auth/me").then(() => navigate("/admin/dashboard")).catch(() => {});
    }
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { email: email.trim().toLowerCase(), password });
      setToken(res.data.token);
      toast.success("Welcome back.");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center px-6 relative">
      <div className="absolute inset-0 starfield opacity-40" />
      <Link to="/" className="absolute top-6 left-6 inline-flex items-center gap-2 text-zinc-400 hover:text-white transition" data-testid="back-to-home">
        <ArrowLeft className="w-4 h-4" /> Home
      </Link>
      <div className="relative w-full max-w-md p-10 rounded-sm glass" data-testid="admin-login-card">
        <div className="flex justify-center mb-6">
          <LacBadge size={80} />
        </div>
        <div className="text-xs tracking-[0.3em] text-[#D946EF] mb-2 text-center">ADMIN PORTAL</div>
        <h1 className="font-display font-bold text-3xl tracking-tighter text-center text-chrome">Sign in to LAC</h1>
        <p className="text-zinc-400 mt-2 font-body text-sm text-center">Manage incoming bookings and customers.</p>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <Label htmlFor="email" className="text-sm text-zinc-300 mb-2 block">Email</Label>
            <Input id="email" type="email" data-testid="login-email-input" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="admin@lac.ltd" required />
          </div>
          <div>
            <Label htmlFor="password" className="text-sm text-zinc-300 mb-2 block">Password</Label>
            <Input id="password" type="password" data-testid="login-password-input" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} placeholder="••••••••" required />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-btn"
            className="w-full inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-[#D946EF] text-white font-semibold disabled:opacity-50 hover:bg-[#F0ABFC] transition"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
